import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Poetic Section - fade in with scale bounce
 */
export const animatePoeticSection = (ref) => {
  if (ref.current) {
    const element = ref.current;
    
    // Set initial state immediately to prevent flash
    gsap.set(element, { opacity: 0, scale: 0.9 });
    
    const timer = setTimeout(() => {
      gsap.to(element, {
        opacity: 1,
        scale: 1,
        duration: 1.2,
        ease: "elastic.out(1, 0.5)",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

